/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import classNames from 'classnames';
import MicImg from 'Assets/images/pages/web-chat/mic.svg';
import MicMutedImg from 'Assets/images/pages/web-chat/mic-disabled.svg';
import CamDisabledImg from 'Assets/images/pages/web-chat/cam-disabled.svg';
import CamImg from 'Assets/images/pages/web-chat/cam.svg';
import BgEffectImg from 'Assets/images/pages/web-chat/bg-effect.svg';
import BgEffectOffImg from 'Assets/images/pages/web-chat/bg-effect-off.svg';
import IconChevronUp from 'Assets/images/pages/web-chat/chevron-up.svg';
import EndCallImg from 'Assets/images/pages/web-chat/phone.svg';
import { any, bool, func } from 'prop-types';
import { Popup } from 'semantic-ui-react';

import ControlButton from './ControlButton/ControlButton';
import css from './VideoControls.less';
import SoundPicker from './DevicePicker/SoundPicker';
import CameraPicker from './DevicePicker/CameraPicker';

const CompactButtonSize = 38;

function VideoControls({
  isMinimized,
  onClose,
  toggleVideo,
  toggleMic,
  isAudioMuted = true,
  isCameraOff,
  userDevices,
  showBackgroundModal,
  isBlur,
  supportVirtualBackground,
  isAttentionAudio,
}) {
  const [disableEndCall, setDisableEndCall] = React.useState(false);
  const emptyCameras = userDevices.cameras.length === 0;
  // const emptyMic = userDevices.mics.length === 0;
  return (
    <div
      className={classNames({
        [css.container]: !isMinimized,
        [css.containerMinimized]: isMinimized,
      })}>
      <div className={css.controlItem}>
        <Popup
          style={{ zIndex: 10000, padding: '0px', width: '300px' }}
          position="left center"
          content={
            <div style={{ width: '360px', padding: '8px 12px' }}>
              Please keep your camera on throughout the call
            </div>
          }
          disabled={emptyCameras}
          on="hover"
          trigger={
            <div>
              <ControlButton
                icon={isCameraOff || emptyCameras ? CamDisabledImg : CamImg}
                gray={emptyCameras}
                showError={emptyCameras}
                onClick={toggleVideo}
                size={isMinimized ? CompactButtonSize : undefined}
                // warning={
                //   emptyCameras
                //     ? 'No camera detected. Please connect one and then restart your browser if necessary.'
                //     : undefined
                // }
              />
            </div>
          }
        />
        {!isMinimized && !emptyCameras && (
          <Popup
            style={{ zIndex: 10000, padding: '0px' }}
            position="top center"
            content={
              <CameraPicker
                activeCamera={userDevices.activeCamera}
                cameras={userDevices.cameras}
                selectCamera={userDevices.selectCamera}
              />
            }
            on="click"
            trigger={<img src={IconChevronUp} alt="menu" style={{ cursor: 'pointer' }} />}
          />
        )}
      </div>
      <div className={css.controlItem}>
        <ControlButton
          icon={isAudioMuted ? MicMutedImg : MicImg}
          onClick={toggleMic}
          size={isMinimized ? CompactButtonSize : undefined}
          isAttentionAudio={isAttentionAudio}
        />
        {!isMinimized && (
          <Popup
            style={{ zIndex: 10000, padding: '0px' }}
            position="top center"
            content={
              <SoundPicker
                activeMicrophone={userDevices.activeMic}
                activeSpeaker={userDevices.activeSpeaker}
                mics={userDevices.mics}
                speakers={userDevices.speakers}
                selectMicrophone={userDevices.selectMicrophone}
                selectSpeaker={userDevices.selectSpeaker}
              />
            }
            on="click"
            trigger={<img src={IconChevronUp} alt="menu" style={{ cursor: 'pointer' }} />}
          />
        )}
      </div>

      {supportVirtualBackground && (
        <ControlButton
          icon={BgEffectImg}
          onClick={showBackgroundModal}
          size={isMinimized ? CompactButtonSize : undefined}
        />
      )}
      <ControlButton
        disabled={disableEndCall}
        onClick={() => {
          if (!disableEndCall) {
            setDisableEndCall(true);
            onClose();
          }
        }}
        icon={EndCallImg}
        background="#E01F5A"
        size={isMinimized ? CompactButtonSize : undefined}
      />
    </div>
  );
}

VideoControls.propTypes = {
  isMinimized: bool.isRequired,
  isAudioMuted: any,
  isCameraOff: bool.isRequired,
  isBlur: bool.isRequired,
  onClose: func.isRequired,
  toggleMic: func.isRequired,
  toggleVideo: func,
  showBackgroundModal: func.isRequired,
  supportVirtualBackground: bool,
  userDevices: any,
  isAttentionAudio: bool.isRequired,
};

export default VideoControls;
